import { render, staticRenderFns } from "./ContactPhonenumber.vue?vue&type=template&id=41f6f154&"
import script from "./ContactPhonenumber.vue?vue&type=script&lang=ts&"
export * from "./ContactPhonenumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports